var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"public-page"},[_c('header',{staticClass:"header"},[_c('common-header',{attrs:{"show-menu":false}})],1),_c('section',[_c('ps-container',[_c('router-view')],1)],1),_c('common-footer',{staticClass:"footer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }